import $ from 'jquery';
import { gsap } from 'gsap';

if( $( '.svg-map-container' ).length ) {
  let vcSVG = document.querySelector( '.svg-vc-map' );
  let $allBays = $('g[id*=building] g');

  vcSVG.setAttribute("preserveAspectRatio", "xMidYMid slice");

  // District Buttons
  let vcAll = $( '.vc-all' );
  let vcDistrict = $( '.vc-district' );
  let vcButton = $( '.vc-button' );

  vcDistrict.on( 'click', ( elem ) => {
    elem.preventDefault();
    const $this = $( elem.currentTarget )

    resetBayActiveClass();
    districtBayCardFilter( $this );
    activeClass( $this, vcButton );
    districtCoords( $this );
  } )

  vcAll.on( 'click', ( elem ) => {
    elem.preventDefault();
    const $this = $( elem.currentTarget )

    resetBayActiveClass();
    districtBayCardFilterReset();
    activeClass( $this, vcButton );
    mapReset();
  } )

  // District Cards
  let bayCards = $( '.bay-card' );
  let nonLeasingbayCards = $( '.non-lease-bay' );

  bayCards.on( 'click', ( elem ) => {
    const $this = $( elem.currentTarget )
    const bayID = $( '#' + $this.data( 'bay' ) )
    const bayDistrict = $( '.vc-district[data-district="' + $this.data( 'district' ) +'"]' )
    
    activeClass( $this, bayCards );
    activeClass( bayDistrict, vcButton );
    activeClass( bayID, $allBays );
    districtCoords( $this );
  } )

  nonLeasingbayCards.on( 'click', ( elem ) => {
    const $this = $( elem.currentTarget )

    districtBayCardFilter( $this );
  } )

  // Mobile Toggle
  let vcMobileToggle = $( '.svg-mobile-toggle' );

  vcMobileToggle.on( 'click', () => {
    toggleLegend();
  } )

  // Leasing Opportunities
  $( '#leasing' ).on( 'click', () => {
    leaseToggle();
    activeClass( vcAll, vcButton );
    resetBayActiveClass();
    districtBayCardFilterReset();
    mapReset();
    showLease();
  } )

  // Bay Click
  $allBays.on( 'click', ( elem ) => {
    let $this = $( elem.currentTarget );
    let bayID = $this.attr( 'id' );
    let $bayCard = $( `.bay-card[data-bay='${ bayID }']` );

    if( $bayCard.hasClass( 'non-lease-bay' ) ) {
      bayClick( $bayCard );
    } else if( $bayCard.hasClass( 'lease-bay' ) ) {
      leaseClick( $bayCard );
    }

    scrollToBayCard( $bayCard );
  } )

  function districtBayCardFilter( elem ) {
    let $thisDistrict = $( elem ).data( 'district' )

    $( '.bay-card' ).removeClass( 'show' )
    $( `.bay-card[data-district="${ $thisDistrict }"` ).addClass( 'show' )
    $( '.accordion' ).removeClass( 'show-accordion' )
    $( '.accordion' ).has( '.show' ).addClass( 'show-accordion' )
  }

  function districtBayCardFilterReset() {
    $( '.bay-card' ).addClass( 'show' )
    $( '.accordion' ).addClass( 'show-accordion' )
  }

  function scrollToBayCard( bayCard ) {
    let $bayCardPos = bayCard.position().top;

    $( '.svg-map-legend' ).delay( 500 ).animate({
      scrollTop: $bayCardPos
    }, 500); 
  }

  function bayClick( elem ) {
    let $thisAccordionTitle = elem.parent().prev();
    let $thisAccordionIsOpen = elem.parent().parent().hasClass( 'open' );
    let $isLeasingChecked = $( '#leasing' ).is( ':checked' )
    
    elem.trigger( 'click' );

    if( $isLeasingChecked ) {
      $( '#leasing' ).prop( 'checked', false );
      leaseToggle();
    }

    if( !$thisAccordionIsOpen ) {
      $thisAccordionTitle.trigger( 'click' );
    }
  }

  function leaseClick( elem ) {
    let $isLeasingChecked = $( '#leasing' ).is( ':checked' )

    $( '#leasing' ).prop( 'checked', true );
    elem.trigger( 'click' );

    if( !$isLeasingChecked ) {
      leaseToggle();
    }
  }

  function activeClass( elem, elemGroup ) {
    $( elemGroup ).removeClass( 'active' );
    $( elem ).addClass( 'active' );
  }

  function resetBayActiveClass() {
    $( bayCards ).removeClass( 'active' );
    $allBays.removeClass( 'active' )
  }

  function mapReset() {
    // get entire svg map bounding box
    let districtBBox = document.querySelector( '.svg-vc-map' ).getBBox();

    // viewBox coordinates
    let vbMinX = 0
    let vbMinY = 0
    let vbWidth = districtBBox.width
    let vbHeight = districtBBox.height

    svgZoom( vbMinX, vbMinY, vbWidth, vbHeight );
    closeLegend();
  }

  function districtCoords( elem ) {
    // get the data-district
    let dataButton = elem.data( 'district' );

    // select ID from data-distrct
    let district = document.querySelector( '#' + dataButton );
  
    // Get bounding box of district
    let districtBBox = district.getBBox();

    // Padding around the shown district (dependant on screen width)
    let viewBoxPadding;

    window.innerWidth < 500
    ? viewBoxPadding = 250
    : viewBoxPadding = 100
    
    // viewBox coordinates
    let vbMinX = districtBBox.x - ( viewBoxPadding / 2 )
    let vbMinY = districtBBox.y - ( viewBoxPadding / 2 )
    let vbWidth = districtBBox.width + viewBoxPadding
    let vbHeight = districtBBox.height + viewBoxPadding

    svgZoom( vbMinX, vbMinY, vbWidth, vbHeight );
    closeLegend();
  }

  function svgZoom( minX, minY, width, height ) {
    // Animation to coordinates
    gsap.to( vcSVG, {
      attr: { viewBox: `${ minX } ${ minY } ${ width } ${ height }` },
      duration: 1.5
    });
  }

  function toggleLegend() {
    $( vcMobileToggle ).toggleClass( 'open' );
    $( '.svg-map-legend' ).toggleClass( 'open' );
  }

  function closeLegend() {
    if( $( '.svg-map-legend' ).hasClass( 'open' ) ) {
      $( vcMobileToggle ).removeClass( 'open' );
      $( '.svg-map-legend' ).removeClass( 'open' );
    }
  }

  function leaseToggle() {
    $( '.district-filter' ).toggleClass( 'hidden' )
    $( '.bay-container' ).toggleClass( 'hidden' )
    $( '.leasing-contact' ).toggleClass( 'hidden' )
    $( '.leasing-container' ).toggleClass( 'hidden' )
  }

  function showLease() {
    let leaseBays = document.querySelectorAll( '.lease-bay' );
    if( $( '#leasing' ).is( ":checked" ) ) {
      leaseBays.forEach( ( elem ) => {
        let leaseID = '#' + $( elem ).data( 'bay' )
  
        $( leaseID ).addClass( 'active' );
      } )
    }
  }
}
